import * as React from 'react';
import { AccordionItem, RichTextArea, Accordion } from '@grandvisionhq/common';
import { compose } from '@grandvisionhq/utils';
import { withAnchor } from '../../hocs/with-anchor.js';
import '@swc/helpers';
import '@grandvisionhq/state';
import '@bloomreach/react-sdk';
import '../../context/configuration.js';
import '@bloomreach/spa-sdk';
import '@grandvisionhq/search';
import 'jsonpointer';
import '../../utils/http-client.js';
import '@grandvisionhq/lib-utils-html';
import '@grandvisionhq/content';
import '@grandvisionhq/graphql';
import '../../operations/mutations/signup-promotion.js';
import '../../operations/mutations/subscribe-newsletter.js';
import '../../operations/mutations/subscribe-newsletter-opt-in.js';
import '@grandvisionhq/svc-tealium/events';
import { useBloomreachRichText } from '../../hooks/use-bloomreach-rich-text.js';
import '../../hooks/use-breakpoint-visibility.js';
import { withBloomreachPageable } from '../../hocs/with-bloomreach-pageable.js';
import { withBreakpointVisibility } from '../../hocs/with-breakpoint-visibility.js';
import { withEditableContent } from '../../hocs/with-editable-content.js';
import { withHidableContent } from '../../hocs/with-hidable-content.js';

const CmsAccordionItem = withEditableContent(({ content , expanded , headingLevel  })=>{
    var ref;
    const richText = useBloomreachRichText((ref = content.content) === null || ref === void 0 ? void 0 : ref.value);
    return /*#__PURE__*/ React.createElement(AccordionItem, {
        id: content.id,
        label: content.title,
        expanded: expanded,
        headingLevel: headingLevel,
        fullWidth: true
    }, /*#__PURE__*/ React.createElement(RichTextArea, {
        content: richText
    }));
});
const CmsAccordion = ({ headingLevel , meta , content  })=>/*#__PURE__*/ React.createElement(Accordion, null, content.items.map((item, i)=>/*#__PURE__*/ React.createElement(CmsAccordionItem, {
            key: item.id,
            content: item,
            headingLevel: headingLevel,
            expanded: meta.expandedByDefault === `${i + 1}`
        })
    ))
;
var CmsAccordion$1 = compose(withBreakpointVisibility, withHidableContent, withBloomreachPageable, withAnchor)(CmsAccordion);

export { CmsAccordion, CmsAccordionItem, CmsAccordion$1 as default };
//# sourceMappingURL=Accordion.js.map
